// src/js/reducers/index.js
import * as types from "../constants/action-types";

  
export default function homeStatReducer(state = {}, action) {


    switch (action.type) {
        
        case types.LOGOUT:
            return []
        case types.LOAD_HOME_STATS_SUCCESS:
            return action.stats;
        default:
            return state;
    };
};
